module.exports = __webpack_public_path__ + "img/fi-other.89745e14.svg";